import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PRODUCTINVENTORYDETAIL,
  DELETE_PRODUCTINVENTORYDETAIL,
  UPDATE_PRODUCTINVENTORYDETAIL,
  ADD_NEW_PRODUCTINVENTORYDETAIL,
} from "./actionType";

import {
  getProductInventoryDetailSuccess,
  getProductInventoryDetailFail,
  deleteProductInventoryDetailSuccess,
  deleteProductInventoryDetailFail,
  updateProductInventoryDetailSuccess,
  updateProductInventoryDetailFail,
  addProductInventoryDetailSuccess,
  addProductInventoryDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveProductInventoryDetailApi,
  getProductInventoryDetailApi,
  updateProductInventoryDetailApi,
  deleteProductInventoryDetailApi,
  addNewProductInventoryDetailApi
} from "../../helpers/backend_helper";

function* getProductInventoryDetail({ payload: productInventoryDetail }) {
  try {
    const response = yield call(getProductInventoryDetailApi, productInventoryDetail);
    yield put(getProductInventoryDetailSuccess(GET_PRODUCTINVENTORYDETAIL, response.data));
  } catch (error) {
    yield put(getProductInventoryDetailFail(GET_PRODUCTINVENTORYDETAIL, error));
  }
}

function* onUpdateProductInventoryDetail({ payload: productInventoryDetail }) {
  try {
    if (productInventoryDetail.setApprove) {
      const response = yield call(approveProductInventoryDetailApi, productInventoryDetail);
      yield put(updateProductInventoryDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateProductInventoryDetailApi, productInventoryDetail);
      yield put(updateProductInventoryDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateProductInventoryDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductInventoryDetail({ payload: productInventoryDetail }) {
  try {
    const response = yield call(deleteProductInventoryDetailApi, productInventoryDetail);
    yield put(deleteProductInventoryDetailSuccess({ productInventoryDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductInventoryDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductInventoryDetail({ payload: productInventoryDetail }) {
  try {
    const response = yield call(addNewProductInventoryDetailApi, productInventoryDetail);
    yield put(addProductInventoryDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductInventoryDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetProductInventoryDetail() {
  yield takeEvery(GET_PRODUCTINVENTORYDETAIL, getProductInventoryDetail);
}

export function* watchUpdateProductInventoryDetail() {
  yield takeEvery(UPDATE_PRODUCTINVENTORYDETAIL, onUpdateProductInventoryDetail);
}

export function* watchDeleteProductInventoryDetail() {
  yield takeEvery(DELETE_PRODUCTINVENTORYDETAIL, onDeleteProductInventoryDetail);
}

export function* watchAddNewProductInventoryDetail() {
  yield takeEvery(ADD_NEW_PRODUCTINVENTORYDETAIL, onAddNewProductInventoryDetail);
}

function* productInventoryDetailSaga() {
  yield all([
    fork(watchGetProductInventoryDetail),
    fork(watchDeleteProductInventoryDetail),
    fork(watchUpdateProductInventoryDetail),
    fork(watchAddNewProductInventoryDetail)
  ]);
}

export default productInventoryDetailSaga;
